<ca-icon [className]="purpose" *ngIf="isCaIcon" [name]="_iconLabel"></ca-icon>
<mat-icon [className]="purpose" *ngIf="!isCaIcon">{{ _iconLabel }}</mat-icon>
